// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconPublic = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.38 4.115a.75.75 0 00-1.178-.616l-1.043.724c-3.245 2.253-7.054 3.453-10.947 3.454H5.14c-2.348 0-4.2 1.974-4.2 4.344s1.852 4.344 4.2 4.344h1.355a7.803 7.803 0 002.257 4.814.75.75 0 001.056-1.066 6.296 6.296 0 01-1.803-3.732 19.212 19.212 0 0110.154 3.438l1.043.724a.75.75 0 001.178-.616V4.115zM7.96 9.163a20.702 20.702 0 0010.92-3.615v12.946a20.702 20.702 0 00-10.92-3.616V9.163zm-5.52 2.858c0-1.6 1.237-2.844 2.7-2.844h1.32v5.688H5.14c-1.463 0-2.7-1.245-2.7-2.844zm19.95-2.188a.75.75 0 01.75.75v2.875a.75.75 0 01-1.5 0v-2.875a.75.75 0 01.75-.75z"
      fill="currentColor"
    />
  );
export default SvgIconPublic;
